@let activeId = activeTabId();

<div class="flex items-center rounded-t-md border-b border-neutral-200 bg-white pr-1">
  <div
    class="relative flex min-w-0 flex-auto items-center transition-[padding] duration-200 ease-in-out"
    [class.pl-9]="showLeftArrow()"
    [class.pr-9]="showRightArrow()"
  >
    @if (showLeftArrow()) {
      <button
        ksIconButton
        iconName="chevron-left"
        size="sm"
        ksTooltipPlacement="bottom"
        class="absolute left-1 z-10"
        [ariaLabel]="'tab.previousTab' | ksTranslate"
        [ksTooltip]="'tab.previousTab' | ksTranslate"
        (click)="activateAdjacentTab(-1)"
      ></button>
    }

    <div
      #tablist
      role="tablist"
      class="scrollbar-hidden flex scrollbar min-w-0 items-center gap-1 overflow-x-auto p-1"
      [attr.aria-label]="'tab.openedTabs' | ksTranslate"
    >
      @for (tab of tabs(); track tab.id; let count = $count; let last = $last) {
        <button
          ksButton
          size="sm"
          role="tab"
          aria-controls="ks-tab-panel"
          [attr.id]="'ks-tab-' + tab.id"
          [attr.aria-selected]="tab.id === activeId"
          [activated]="tab.id === activeId"
          [disabled]="count < 2"
          (click)="activateTab(tab.id)"
        >
          <div class="flex gap-2">
            <div
              class="w-40 flex-auto truncate text-left label-xs font-normal"
              [class.!font-medium]="tab.id === activeId"
            >
              {{ tab.title | ksTranslate: tab.titleParams }}
            </div>
            <button
              ksIconButton
              iconName="close"
              size="3xs"
              [ariaLabel]="'common.action.close' | ksTranslate"
              [disabled]="count < 2"
              (click)="closeTab($event, tab.id)"
            ></button>
          </div>
        </button>

        @if (!last) {
          <div class="h-4 w-0 border-l border-neutral-200"></div>
        }
      }
    </div>

    @if (showRightArrow()) {
      <button
        ksIconButton
        iconName="chevron-right"
        size="sm"
        ksTooltipPlacement="bottom"
        class="absolute right-1 z-10"
        [ariaLabel]="'tab.nextTab' | ksTranslate"
        [ksTooltip]="'tab.nextTab' | ksTranslate"
        (click)="activateAdjacentTab(1)"
      ></button>
    }
  </div>

  <button
    ksIconButton
    iconName="pin"
    size="sm"
    ksTooltipPlacement="bottom"
    [ariaLabel]="'tab.pinnedItems' | ksTranslate"
    [ksTooltip]="'tab.pinnedItems' | ksTranslate"
  ></button>
</div>
